import React from 'react';
 
const ComboIdProcesamiento = (props) => {
    const { infoData, titulo, seleccionIdProceso } = props
    


    return (
        <div>
            <div className='labelComboProcesos'>{titulo}</div>
            <select id="selectComboIdProcesamiento" className="selectComboProcesos wideCombo"onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    seleccionIdProceso(value);
            }}>
                <option  key={0} value={0}>Seleccione...</option> 
                {infoData.length>0 && infoData.map( (item,index) => {return <option style={{color:"black"}} key={index} value={item.ID}>{item.ID + " - Registros " + item.CantidadRegistrosOk }</option>} )}
            </select>
        </div>
    );
}

export default ComboIdProcesamiento;